import React from 'react';
import { JitsiWrapper } from '../../../plugins/JitsiWrapper';
import { videoCallConstants } from '../../constants/videoCall.constants';
import PhoneIcon from '@material-ui/icons/Phone';
import './CallStyle.css'
import SystemLabel from '../../../system/SystemLabel/SystemLabel';
import PhoneDisabledIcon from '@material-ui/icons/PhoneDisabled';
import CallEndIcon from '@material-ui/icons/CallEnd';
import { Button } from '@material-ui/core';
import Draggable from 'react-draggable';
import DragIndicatorTwoToneIcon from '@material-ui/icons/DragIndicatorTwoTone';
function MaxWidthDialog(props) {
    const [fullSize, toggleSize] = React.useState(true)

    return (
        <Draggable
            axis="both"
            handle=".handle"
            defaultPosition={{ x: 5, y: 5 }}
            position={null}
            grid={[25, 25]}
            bounds="body"
        >

            <div style={{
                position: 'absolute', zIndex: 10000002, top: '10vh',
                left: '13vw',
            }}>
                <div
                    style={{
                        width: !fullSize ? '40vw' : '80vw',
                        height: !fullSize ? '40vh' : '80vh',
                        maxWidth: '1400px',
                        position: 'relative'
                    }}
                >
                    <div className="handle" style={{
                        position: 'absolute', zIndex: 10000002, left: '2%',
                        top: '2%',
                    }}>
                        <DragIndicatorTwoToneIcon className="jir-drag-icon" style={{ color: '#fff', transform: 'rotate(90deg)', fontSize: '34px' }} />
                    </div>
                    <div style={{ flex: '1 1 auto', height: '100%' }}>
                        {props.children}
                    </div>
                </div>
            </div>
        </Draggable >
    );
}

const callingIconText = () => {

}

export default class VideoFrame extends React.Component {
    renderCallLoader = (targetPerson) => {
        const { videoCallActive, videoCallTarget, videoResponse, clientKey, videoCallResponse, closeVideoCall, callId, lang } = this.props;
        if (videoCallResponse == videoCallConstants.CALL_DENIED) {
            return (
                <h4 className="centered-text">
                    <div className="call-animation-end">
                        <PhoneDisabledIcon style={{
                            top: '26%',
                            position: 'absolute',
                            color: '#fff',
                            left: '23%',
                            fontSize: '50px'
                        }} />
                    </div>
                    <br />
                    <div> {targetPerson} {" "}<SystemLabel name="DeniedCall" languageCode={lang} /></div>
                </h4>
            )
        }
        if (videoCallResponse == videoCallConstants.SELF_HANGUP) {
            return (
                <h4 className="centered-text">
                    <div className="call-animation-end">
                        <CallEndIcon style={{
                            top: '26%',
                            position: 'absolute',
                            color: '#fff',
                            left: '23%',
                            fontSize: '50px'
                        }} />
                    </div>
                    <br />
                    <div> <SystemLabel name="YouHungUp"  languageCode={lang} /></div>
                </h4>
            )
        }
        if (videoCallResponse == videoCallConstants.TARGET_HANGUP) {
            return (
                <h4 className="centered-text">
                    <div className="call-animation-end">
                        <CallEndIcon style={{
                            top: '26%',
                            position: 'absolute',
                            color: '#fff',
                            left: '23%',
                            fontSize: '50px'
                        }} />
                    </div>
                    <br />
                    <div> {targetPerson} {" "}<SystemLabel name="HungUp"  languageCode={lang} /></div>
                </h4>
            )
        }
        return (
            <h4 className="centered-text">
                <div className="call-animation">
                    <PhoneIcon style={{
                        top: '26%',
                        position: 'absolute',
                        color: '#5e7bff',
                        left: '23%',
                        fontSize: '50px'
                    }} />
                </div>
                <br />
                <h2> <SystemLabel name="YouAreCalling"  languageCode={lang} />{" "}{targetPerson}</h2>
                <br />
                <br />
                <div style={{ textAlign: 'center', width: '100%' }}>
                    <Button className="call-btn end" onClick={() => videoResponse(false, videoCallTarget, callId, true)} color="primary">
                        <CallEndIcon />
                    </Button>
                </div>
            </h4>
        )
    }
    render() {
        const { videoCallActive, videoCallTarget, videoResponse, clientKey, clientName, closeVideoCall, targetPerson = '' , meetingCode = ''} = this.props;
        if (!videoCallTarget) return null;
        return (
            <MaxWidthDialog>
                {videoCallActive ? (
                    <JitsiWrapper roomName={meetingCode} displayName={clientName} height={'100%'} onHangup={() => closeVideoCall(videoCallTarget)} />
                ) : <div style={{ height: '100%', backgroundColor: '#000', color: '#fff' }} >{this.renderCallLoader(targetPerson)}</div>}
            </MaxWidthDialog>
        )
    }
}


